import { render, staticRenderFns } from "./ChooseEventDialog.vue?vue&type=template&id=31c5fe7d&scoped=true&"
import script from "@/views/Users/Student/Dialogs/ChooseEventDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Student/Dialogs/ChooseEventDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Student/Dialogs/choose-event-dialog.scss?vue&type=style&index=0&id=31c5fe7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c5fe7d",
  null
  
)

export default component.exports